import { render, staticRenderFns } from "./MyEventsView.vue?vue&type=template&id=0442aeee&"
import script from "./MyEventsView.vue?vue&type=script&lang=js&"
export * from "./MyEventsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports